import PropTypes from 'prop-types';
import styles from './FJMobileTextToImageEditFooter.module.less';
import FJTextToImageDataConfig from '../../../config/dataConfig/FJTextToImageDataConfig';
import FJLocalStore from '../../../store/FJLocalStore';
import classNames from 'classnames';
import FJImageIcon from '../../../assets/svg/mobile-image.svg?react';
import FJNoneIcon from '../../../assets/svg/mobile-none.svg?react';
import FJConstant from '../../../constants/FJConstant';
const FJMobileTextToImageEditFooter = props => {
    const { curModel, curStyle, curRatio, generateNumber, showFooterModal } = props;
    const curModelObj = FJTextToImageDataConfig.MODELS.find(item => item.value === curModel);
    const curRatioObj = FJTextToImageDataConfig.RATIO_LIST.find(item => item.name === curRatio);

    const _onShowFooter = (e, type) => {
        e.stopPropagation();
        showFooterModal({
            type,
            hasMask: true,
        });
    };

    return (
        <div className={styles.footer_box}>
            <div
                className={classNames(styles.footer_item)}
                onClick={e => _onShowFooter(e, FJConstant.TEXT_TO_IMAGE_MODAL)}
            >
                <curModelObj.icon className={styles.footer_item_icon} />
                <div className={styles.footer_item_text}>{FJLocalStore._(curModelObj.name)}</div>
            </div>
            <div
                className={classNames(styles.footer_item)}
                onClick={e => _onShowFooter(e, FJConstant.TEXT_TO_IMAGE_RATIO)}
            >
                <curRatioObj.icon className={styles.footer_item_icon} />
                <div className={styles.footer_item_text}>{FJLocalStore._(curRatioObj.name)}</div>
            </div>
            <div
                className={classNames(styles.footer_item)}
                onClick={e => _onShowFooter(e, FJConstant.TEXT_TO_IMAGE_GENERATE_NUMBER)}
            >
                <FJImageIcon className={styles.footer_item_icon} />
                <div className={styles.footer_item_text}>{generateNumber}</div>
            </div>
            <div
                className={classNames(styles.footer_item)}
                onClick={e => _onShowFooter(e, FJConstant.TEXT_TO_IMAGE_STYLE)}
            >
                {!curStyle.value ? (
                    <FJNoneIcon className={styles.footer_item_icon} />
                ) : (
                    <img className={classNames(styles.footer_item_img)} src={curStyle.previewImg} />
                )}
                <div className={styles.footer_item_text}>{FJLocalStore._(curStyle.name)}</div>
            </div>
        </div>
    );
};
FJMobileTextToImageEditFooter.propTypes = {
    generateNumber: PropTypes.number,
    onChangeGenerateNumber: PropTypes.func,
    curRatio: PropTypes.string,
    onChangeRatio: PropTypes.func,
    curModel: PropTypes.string,
    onChangeModel: PropTypes.func,
    curStyle: PropTypes.object,
    onChangeStyle: PropTypes.func,
    styleList: PropTypes.array,
    showFooterModal: PropTypes.func,
};
export default FJMobileTextToImageEditFooter;
